import { useTranslation } from 'react-i18next';
import {
  ToggleButton,
  ToolbarIcon,
  TextEditorToolbarSection,
} from '../../styles';
import { useGridLikeFlexChildProps } from 'components/StandaloneToolBar/components/GridLikeFlex';
import { useMarkdownEditor } from 'components/WYSIWYG/MarkdownEditor/context';
import { useEffect, useState } from 'react';

export const CodeToolbarSection = () => {
  const { t } = useTranslation();
  const { editor, subscribeToUpdate, subscribeToSelectionUpdate } =
    useMarkdownEditor();
  const [ref, props] = useGridLikeFlexChildProps();

  const [
    { codeBlockActive, inlineCodeActive, canSetCodeBlock, canSetInlineCode },
    setState,
  ] = useState(() => ({
    codeBlockActive: editor?.isActive('codeBlock'),
    inlineCodeActive: editor?.isActive('code'),
    canSetCodeBlock: editor?.can().toggleCodeBlock(),
    canSetInlineCode:
      editor?.can().toggleCode() && !editor?.isActive('codeBlock'),
  }));

  useEffect(() => {
    const handler = ({ editor }) => {
      if (!editor) {
        return;
      }
      const isCodeBlockActive = editor.isActive('codeBlock');
      setState({
        codeBlockActive: isCodeBlockActive,
        canSetCodeBlock: editor.can().toggleCodeBlock({}),
        inlineCodeActive: editor.isActive('code'),
        canSetInlineCode: editor.can().toggleCode() && !isCodeBlockActive,
      });
    };

    const selectionUnsubscribe = subscribeToSelectionUpdate(
      'code-toolbar-section',
      handler
    );
    const updateUnsubscribe = subscribeToUpdate(
      'code-toolbar-section',
      handler
    );

    return () => {
      selectionUnsubscribe();
      updateUnsubscribe();
    };
  }, [subscribeToSelectionUpdate, subscribeToUpdate]);

  if (!editor) {
    return null;
  }

  return (
    <TextEditorToolbarSection ref={ref} {...props}>
      <ToggleButton
        active={inlineCodeActive}
        title={t('Inline Code')}
        onClick={() => editor.chain().focus().toggleCode().run()}
        disabled={!canSetInlineCode}
      >
        <ToolbarIcon
          icon="code-simple"
          color={
            canSetInlineCode
              ? 'var(--color-background-darker)'
              : 'var(--color-background-medium)'
          }
        />
      </ToggleButton>
      <ToggleButton
        active={codeBlockActive}
        title={t('Code Block')}
        onClick={() => {
          if (codeBlockActive) {
            editor.chain().focus().setParagraph().run();
          } else {
            editor.chain().focus().toggleCodeBlock().run();
          }
        }}
        disabled={!canSetCodeBlock}
      >
        <ToolbarIcon
          icon="rectangle-code"
          color={
            canSetCodeBlock
              ? 'var(--color-background-darker)'
              : 'var(--color-background-medium)'
          }
        />
      </ToggleButton>
    </TextEditorToolbarSection>
  );
};
